import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material";
import { Avatar } from "primereact/avatar";

import MenuIcon from "@mui/icons-material/Menu";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { styled } from "@mui/material/styles";
import "./SideMenu.scss";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";

import axios from "axios";
import { FaUser } from "react-icons/fa";
const drawerWidth = 300;

// Styled AppBar that adapts to the drawer state
const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: "white",
  borderBottom: "2px solid #bb1ccc",
  boxShadow: "none",
  marginLeft: open ? drawerWidth : 80, // <-- Here marginLeft is 240 if open, else 80
  width: open ? `calc(100% - ${drawerWidth}px)` : `calc(100% - 75px)`, // adjust width accordingly
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
}));

const Header = ({ open, handleDrawerOpen, text="Test" }) => {
  const { accounts, instance } = useMsal();
  const account = accounts?.[0];
  const name = account?.name || "User";
  const email = account?.username || "User";
  const [photo, setPhoto] = useState(null);

  const getProfilePhoto = async () => {
    try {
      const response = await instance.acquireTokenSilent({
        scopes: ["User.Read"], // Use proper Microsoft Graph scopes
        account: accounts[0],
      });
  
      const token = response.accessToken;
  
      const photoResponse = await axios.get(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "arraybuffer",
        }
      );
  
      const blob = new Blob([photoResponse.data], { type: "image/jpeg" });
      const imageUrl = URL.createObjectURL(blob);
      setPhoto(imageUrl);
    } catch (err) {
      console.error("Error fetching profile photo", err);
    }
  };
  

  useEffect(() => {
    getProfilePhoto();
  }, []);
  console.log("photo Details:", photo);
  return (
    <StyledAppBar className="welcome-screen"  position="fixed" open={open}>
      <Toolbar>
        {/* Hamburger menu only shown when drawer is closed */}
        {!open && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2 }}
          >
            <MenuIcon sx={{ color: "black" }} />
          </IconButton>
        )}

        {/* Title */}
        <Typography
          className="menuHeader"
          sx={{ color: "black", fontSize: "20px", fontWeight: "600" }}
          variant="h6"
          noWrap
          component="div"
        >
          {text}
        </Typography>

        {/* Spacer */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Icons section */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 3,
            alignContent: "center",
          }}
        >
          <IconButton>
            <NotificationsNoneIcon sx={{ color: "black", fontSize: "28px" }} />
          </IconButton>
          <Typography
          className="menuHeader"
          sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
          variant="div"
          noWrap
          component="div"
        >
         
          <div className="grid text-right">
              <span style={{fontWeight:"600"}}> {name}</span>
              <span style={{fontWeight:"400", fontSize:"12px"}}>{email}</span>

          </div>
        </Typography>


          <Avatar
            image={photo}
            data-pr-tooltip={name || "User"}
            style={{
              verticalAlign: "top",
              position: "relative",
              backgroundColor: "#cbcbcb",
              height: "35px",
              width: "35px",
            }}
            icon={<FaUser />}
            shape="circle"
          />
        </Box>
      </Toolbar>
    </StyledAppBar>
  );
};

export default Header;
